export const accountProperties = '/account-history/api/account/:account/property';
export const accountUnassignedTeamMembers = '/account-history/api/account/:id/property/:property/unassigned-team-member';
export const accountPropertiesDetails = '/account-history/api/account/:id/property/:property';

export const accountPropertiesUpdate = '/property/account/:id/property/:property';
export const accountPropertiesAssignTeamMember = '/property/account/:id/property/:property/team-member';
export const accountPropertyBulkUpdate = '/property/account/:id/property-bulk-update';
export const accountCreateCorporateSite = '/property/account/:id/corporate';
